import { useLayoutEffect, type RefObject } from 'react';

/** 모달이 뷰포트보다 길 때만 오버레이 하단 스크롤 여백 클래스를 켠다. */
export function useModalBackdropOverflowPad(
  enabled: boolean,
  backdropRef: RefObject<HTMLElement | null>,
  modalRef: RefObject<HTMLElement | null>,
  observeKey?: unknown
): void {
  useLayoutEffect(() => {
    const backdrop = backdropRef.current;
    const modal = modalRef.current;
    if (!enabled || !backdrop || !modal) return undefined;

    const sync = () => {
      const styles = window.getComputedStyle(backdrop);
      const topPad = Number.parseFloat(styles.paddingTop) || 0;
      const available = backdrop.clientHeight - topPad * 2;
      const overflowing = modal.scrollHeight > available + 1;
      backdrop.classList.toggle('is-modal-overflowing', overflowing);
    };

    sync();
    const observer = new ResizeObserver(sync);
    observer.observe(modal);
    observer.observe(backdrop);
    window.addEventListener('resize', sync);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', sync);
      backdrop.classList.remove('is-modal-overflowing');
    };
  }, [backdropRef, enabled, modalRef, observeKey]);
}
